// naschval tu zbieram globalne vsetky typy pages co mame vo formoch,
// aby sme videli, co sa da reusovat
export enum FormPageType {
    Main,
    Photos,
    Stickers,
    SelectTopicCategory,
    SelectGroupCategory,
    SelectScore,
    SelectFacetValue,
    ChangeGroupCover,
    ChangeTopicCover,
    ChangeAvatar,
    SignupPhoneVerification,
    SignupPhotoUpload,
    SignupTokenValidation,
    AnonymousModeExplanation,
}
